import React, { useEffect, useState } from "react";
import "./SummaryStatistics.scss";
import { useAppDispatch } from "../../store";
import { Button, Loader } from "@scuf/common";
import { setActiveDashboardTab } from "../../slices/userProfileSlice";
import Alert from "../../images/Alert.png";
import { ALERT, FILTER_LABEL_NAME, FILTER_GROUP_NAMES,REVIEW_IMMIDIATELY_TEXT } from "../../constants/constants";
import { useNavigate } from "react-router-dom";
import { RouteConstants,DASHBOARD_TABS } from "../../constants/constants";
import { setQuickSummaryType, getallOpportunities, clearAllFilters } from '../../slices/allOpportunitySlice';
import { setOverviewViewType } from '../../slices/overviewSlice';
import { getReviewImmediately } from "src/services/Dashboard";
import FontIcon from "../FontIcon/FontIcon";
import { getMessage } from '../../message/utils';

interface ISummaryStatistics {
  isLandingPage: boolean;
  hideSummaryStatistics: Function;
  addExtraWidth?: boolean;
}interface IOverview {
  icon: string;
  title: string;
  view_type: string;
}

const SummaryStatistics = (props: ISummaryStatistics) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [reviewImmediately, setReviewImmediately] = useState([] as any);
  const [loader, setLoader] = useState(true);
  const quickSummary: string = getMessage('app.tab.dropdown.quicksummary');
  const fetchingData: string = getMessage('app.tab.dropdown.fetchingquicksummary');
  const review: string = getMessage('app.tab.dropdown.quicksummary.review');
  const skip: string = getMessage('app.tab.dropdown.quicksummary.skip');

  useEffect(() => {
    getReviewImmediately()
      .then((response: any) => {
        setLoader(false);

        setReviewImmediately(response.overview || []);
      })
      .catch(() => {
        console.log("error");
        setLoader(true);

      });
  }, []);

  const handleReview = (type: string) => {
    dispatch(clearAllFilters([]))
    dispatch(setActiveDashboardTab(DASHBOARD_TABS.ALL_OPPORTUNITIES));
    navigate(RouteConstants.DASHBOARD);
    dispatch(setQuickSummaryType(type));
    dispatch(setOverviewViewType(""));
    dispatch(getallOpportunities());
  }

  return (
    <div>
      <div
        className={`layout ${!props.isLandingPage ? "sidebar" : ""} ${props.addExtraWidth ? "extra-margin" : ""
          }`}
      >
        {props.isLandingPage && (
          <div className="layout__header">{quickSummary}</div>
        )}

        <div className="layout__content">
          {loader ? (
            <Loader
              className="review__loader"
              loading={loader}
              text={fetchingData}
              minHeight="28vh"
              max-height="70vh"
              overlayColor="transparent"
            />
          ) : <>  {reviewImmediately.map((item: IOverview, idx: number) => (
            <div key={idx} className="layout__card">
              {idx === 0 && !props.isLandingPage && (
                <FontIcon className="close_layout" iconName="fa-close" iconSize="large" onClick={() => props.hideSummaryStatistics()}/>           
              )}
              <div className="layout__card--content">
                <div className="layout__card--icon">
                  {
                    item.icon === "alert" && <FontIcon iconName="fa-exclamation-triangle" iconSize="medium"/>
                  }
                </div>
                <div className="layout__card--text">{item.title}</div>
              </div>
              <div className="layout__card--footer">
                <Button
                  className={`button--secondary`}
                  iconPosition="right"
                  size="medium"
                  type="secondary"
                  content={review}
                  onClick={() => {handleReview(item.view_type); props.hideSummaryStatistics()}}
                />
              </div>
            </div>
          ))}
          </>
          }
        </div>
        <div className="layout__footer">
          {props.isLandingPage && (
            !loader &&
            <Button
              className={`button--primary`}
              iconPosition="right"
              size="small"
              type="primary"
              content={skip}
              onClick={() => {
                dispatch(setActiveDashboardTab(DASHBOARD_TABS.OVERVIEW))
                //dispatch(setActiveDashboardTab(0));
                navigate(RouteConstants.DASHBOARD);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SummaryStatistics;
